import React from "react";
import "./homepage.css";
import acejaylogo from "..//..//images/acejaylogo.png";
import Servicescomp from "..//../components/services/Servicescomp";
import News from "..//../components/news/News";

export default function Homepage() {
  return (
    <div className="homepage">
      <div className="imagecontainer"></div>

      <div className="afterimage">
        <div className="left">
          <h2>WELCOME TO</h2>
          <h1 className="name33">ACE JAY AUTO LTD</h1>
          <h2>We Offer Full Range of</h2>
          <h2>Garage Services</h2>
          <h2>We are located in Nakuru Lanet, at Jambo Center</h2>
          <h3 className="name33">Call us on +254799086865</h3>
        </div>
        <div className="right">
          <img src={acejaylogo} alt="" />
        </div>
      </div>
      <div className="secondafterimage">
        <div className="spacer3"></div>
        <News />
      </div>

      <div className="final">
        <div className="spacer2"></div>
        <Servicescomp />
      </div>
    </div>
  );
}
